import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(`${BASE_URL}/authentication-service`, null, {
  headers: {
    contentType: 'application/json',
  },
});

const downloadAPI = new API(BASE_URL, null, {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  responseType: 'blob',
});

class UserService {
  static fetchProfile = async () => {
    return api.get(urls.USER.PROFILE);
    // return res;
  };

  static editProfile = data => {
    // return api.put(urls.USER.PROFILE, data, localStorage.getItem('user_id'));
    return api.put(urls.USER.PROFILE, data);
  };

  static switchProfile = query => {
    return api.get(`${urls.USER.SWITCH_PROFILE}${query}`);
  };

  static downloadDocument = query => {
    return downloadAPI.get(`${urls.USER.DOWNLOAD_DOCUMENT}`, null, query);
  };
}

export default UserService;
